// ============================================
// Transição global de Dialog: no mobile (<sm) todo dialog é um bottom sheet
// e sobe deslizando; no desktop mantém o fade padrão. Ligada no tema
// (MuiDialog.defaultProps) — nenhum dialog precisa saber disso.
// ============================================

import { forwardRef, type ReactElement, type Ref } from 'react'
import Fade from '@mui/material/Fade'
import Slide from '@mui/material/Slide'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import type { TransitionProps } from '@mui/material/transitions'

// Curva de sheet (padrão iOS/Material): entra decidida, assenta macia.
const SHEET_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)'

export const DialogTransition = forwardRef(function DialogTransition (
  props: TransitionProps & { children: ReactElement },
  ref: Ref<unknown>
) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })
  return isMobile
    ? (
      <Slide
        direction="up"
        ref={ref}
        timeout={{ enter: 320, exit: 220 }}
        easing={{ enter: SHEET_EASING, exit: 'ease-in' }}
        {...props}
      />
      )
    : <Fade ref={ref} {...props} />
})
